import React, { forwardRef } from 'react';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  style?: { [key: string]: string | number };
  id?: string;
  className?: string;
  backgroundColor?: string;
};

export const Section = forwardRef<HTMLElement, Props>((props, ref) => {
  return (
    <S.SectionWrapper
      {...props}
      ref={ref}
      className={props.className}
      backgroundColor={props.backgroundColor}
    >
      {props.children}
    </S.SectionWrapper>
  );
});

export default Section;
